<template>
  <div class="wrapper d-flex align-center justify-center">
    <v-card class="login-card pa-6" elevation="6">
      <v-card-title class="justify-center mb-4">
        <img src="/img/logo.png" width="100" />
      </v-card-title>

      <div class="text-center">
        <h2 class="text-h5 font-weight-bold mb-2">Acesso Negado</h2>
        <p class="text-subtitle-1 mb-6">Você não tem permissão para acessar este recurso.</p>

        <v-btn color="primary" @click="$router.push(rotaInicial)" rounded large class="mb-3">
          Voltar para o inicio
        </v-btn>
        <br />
        <v-btn color="primary" @click="$router.push({ name: 'logout' })" rounded large outlined>
          Sair
        </v-btn>
      </div>
    </v-card>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "NaoAutorizado",
  computed: {
    ...mapGetters("Auth", ["user"]),
    rotaInicial() {
      const roleName = this.user ? this.user.roleName : "";
      return roleName === "professor" || roleName === "prof-auxiliar"
        ? { name: "acessoProfessor.home" }
        : { name: "home" };
    },
  },
};
</script>

<style scoped>
.wrapper {
  height: 100vh;
  width: 100vw;
  background-image: url("../assets/background.png");
  background-size: cover;
  background-position: center;
}
.login-card {
  width: 90vw;
  max-width: 500px;
  background-color: rgba(255, 255, 255, 0.85);
  border-radius: 16px;
}
</style>
